/**
 * @generated SignedSource<<c2d51c5b1f4c7d74b1900c86437d3cb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentActiveWaitingCustomerFillData_charge$data = {
  readonly id: string;
  readonly paymentMethodSelected: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActivePixCobValue_charge" | "PaymentLinkActiveCashbackFidelityBalance_charge" | "PaymentLinkActiveEarnCashbackFidelity_charge" | "PaymentLinkActiveEarnCashback_charge" | "PaymentLinkAdditionalInfo_charge" | "PaymentLinkComment_charge" | "PaymentLinkPaymentTerm_charge" | "PaymentLinkTransactionDetails_charge">;
  readonly " $fragmentType": "PaymentActiveWaitingCustomerFillData_charge";
};
export type PaymentActiveWaitingCustomerFillData_charge$key = {
  readonly " $data"?: PaymentActiveWaitingCustomerFillData_charge$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentActiveWaitingCustomerFillData_charge">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentActiveWaitingCustomerFillData_charge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentActivePixCobValue_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkTransactionDetails_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkAdditionalInfo_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkPaymentTerm_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkComment_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveEarnCashback_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveCashbackFidelityBalance_charge"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentLinkActiveEarnCashbackFidelity_charge"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentMethodSelected",
      "storageKey": null
    }
  ],
  "type": "Charge",
  "abstractKey": null
};

(node as any).hash = "0a47db1842b8bf44e3849088a562f4fa";

export default node;
